import { isWeb } from '@/constants/environment'
import { exitingAnimationDurationMs } from '@/features/common/components/Toast/constants'
import { Gesture } from 'react-native-gesture-handler'
import { runOnJS, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated'
import { UnistylesRuntime } from 'react-native-unistyles'

const swipeThreshold = 100

export const useHideOnSwipe = (hide: () => void) => {
    const leftPosition = UnistylesRuntime.screen.width * 0.06

    const left = useSharedValue(leftPosition)

    const wasSwiped = useSharedValue(false)

    const gesture = Gesture.Pan()
        .enabled(!isWeb)
        .onUpdate((e) => {
            if (e.translationX < 0) left.value = leftPosition + e.translationX
        })
        .onEnd(() => {
            if (left.value < -swipeThreshold) {
                wasSwiped.value = true

                left.value = withTiming(
                    -1200,
                    { duration: exitingAnimationDurationMs },
                    runOnJS(hide)
                )

                return
            }

            left.value = withTiming(leftPosition, { duration: exitingAnimationDurationMs })
        })

    const animatedStyle = useAnimatedStyle(() => ({
        left: left.value,
    }))

    return { wasSwiped, gesture, animatedStyle }
}
